var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuNav'),_vm._v(" "),(_vm.channel !== 'catering')?_c('FeaturedBanner',{attrs:{"blok":_vm.story.content.body}}):_vm._e(),_vm._v(" "),_c('MenuCategories')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }